import React, { useState } from "react";
import { BiEdit, BiTrash } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { WrittenFormat } from "../WrittenFormat";
import LabelSelectionModal from "../LabelSelectionModal/LabelSelectionModal";
import DeleteConfirmationModal from "../DeleteConfirmationModal/DeleteConfirmationModal";

export const RenderLabels = ({
  labelsData,
  setModalTab,
  setShowModal,
  onEditLabel,
  onDeleteLabel,
  courtRef, // Added courtRef prop
  refreshLabels,
  refreshCaseDetailLabels,
}) => {
  const navigate = useNavigate();
  const [showLabelSelection, setShowLabelSelection] = useState(false);
  const [expandedDescriptions, setExpandedDescriptions] = useState({});
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    labelId: null,
    labelName: "",
  });

  // Helper function to truncate text by word count
  const truncateText = (text, wordLimit = 20, charLimit = 100) => {
    if (!text) return "";
    const words = text.split(/\s+/);
    if (words.length <= wordLimit && text.length <= charLimit) return text;

    // Truncate by word limit first
    let truncated = words.slice(0, wordLimit).join(" ");
    // If still over char limit, truncate by char limit
    if (truncated.length > charLimit) {
      truncated = truncated.slice(0, charLimit);
      // Remove trailing incomplete word
      truncated = truncated.replace(/\s+\S*$/, "");
    }
    return truncated + "...";
  };

  // Helper function to get word count
  const getWordCount = (text) => {
    if (!text) return 0;
    return text.split(/\s+/).filter((word) => word.length > 0).length;
  };

  const getCharCount = (text) => (text ? text.length : 0);

  // Toggle description expansion
  const toggleDescription = (labelId, e) => {
    e.stopPropagation();
    setExpandedDescriptions((prev) => ({
      ...prev,
      [labelId]: !prev[labelId],
    }));
  };

  // Handle both array and object formats for labelsData
  const labels = Array.isArray(labelsData)
    ? labelsData
    : labelsData?.labels || [];
  const totalLabels = Array.isArray(labelsData)
    ? labelsData.length
    : labelsData?.labelCount || labels.length;

  const handleLabelAdded = async (addedLabelIds) => {

    // Call the refresh function from parent
    if (refreshLabels && typeof refreshLabels === "function") {
      await refreshLabels();
    }

    // Also refresh the case detail labels (if parent component provides this function)
    if (
      refreshCaseDetailLabels &&
      typeof refreshCaseDetailLabels === "function"
    ) {
      await refreshCaseDetailLabels();
    }
  };

  const handleDeleteClick = (labelId, labelName) => {
    setDeleteModal({ isOpen: true, labelId, labelName });
  };

  const handleConfirmDelete = async () => {
    await onDeleteLabel(deleteModal.labelId);
    setDeleteModal({ isOpen: false, labelId: null, labelName: "" });
  };

  const handleCancelDelete = () => {
    setDeleteModal({ isOpen: false, labelId: null, labelName: "" });
  };

  const handleLabelClick = (labelId) => {
    navigate(`/home/labels/${labelId}`);
  };

  return (
    <div className="tab-content">
      <div className="summary">
        <div className="sum-amount">
          <p className="margin-zero">
            <strong>Total Labels:</strong> {totalLabels}
          </p>
          <p className="margin-zero exp-count">
            <strong>Active Labels:</strong>{" "}
            {labels.filter((label) => label.isActive !== false).length}
          </p>
        </div>
        <div className="tab-add">
          <button
            onClick={() => {
              setShowLabelSelection(true);
            }}
          >
            Add Label
          </button>
        </div>
      </div>

      {labels.length === 0 ? (
        <div className="no-data-container">
          <h3 className="no-data-title">No Labels Found</h3>
          <p className="no-data-message">
            No labels have been created for this case yet. Click "Add Label" to
            create your first label.
          </p>
        </div>
      ) : (
        labels.map((label, index) => (
          <div
            key={label._id || index}
            className="order-card"
            style={{ cursor: "pointer" }}
            onClick={() => handleLabelClick(label._id)}
          >
            <div className="order-expense-card">
              {/* --- FIRST COLUMN --- */}
              <div>
                <p>
                  <strong>Name:</strong> {label.name}
                </p>
                {/* DESCRIPTION <p> BLOCK WAS HERE. IT HAS BEEN MOVED BELOW. */}
                <p>
                  <strong>Priority Level:</strong>{" "}
                  {WrittenFormat(label.priorityLevel)}
                </p>
                {/* {label.branchId && (
                  <p>
                    <strong>Branch ID:</strong> {label.branchId}
                  </p>
                )} */}
                {label.createdAt && (
                  <p>
                    <strong>Created:</strong>{" "}
                    {new Date(label.createdAt).toLocaleDateString()}
                  </p>
                )}

                {/* --- DESCRIPTION BLOCK MOVED HERE --- */}
                <p
                  style={{
                    paddingRight: "20px",
                    wordBreak: "break-word",
                    maxWidth: "100%",
                  }}
                >
                  <strong>Description:</strong>{" "}
                  {expandedDescriptions[label._id]
                    ? label.description
                    : getWordCount(label.description) > 20 ||
                      getCharCount(label.description) > 120
                    ? (
                      <>
                        {truncateText(label.description, 20, 120)}...{" "}
                        {/* <button
                          onClick={(e) => toggleDescription(label._id, e)}
                        >
                          Show More
                        </button> */}
                      </>
                    )
                    : label.description}
                  {expandedDescriptions[label._id] &&
                    (getWordCount(label.description) > 20 ||
                      getCharCount(label.description) > 120) && (
                      <>
                        {" "}
                        {/* <button
                          onClick={(e) => toggleDescription(label._id, e)}
                        >
                          Show Less
                        </button> */}
                      </>
                    )}
                </p>
                {/* --- END MOVED BLOCK --- */}
              </div>
              
              {/* --- SECOND COLUMN --- */}
              <div>
                <p>
                  <strong>Color:</strong>
                  <span
                    style={{
                      backgroundColor: label.color,
                      padding: "2px 8px",
                      marginLeft: "8px",
                      borderRadius: "4px",
                      color: "#fff",
                      fontSize: "12px",
                    }}
                  >
                    {label.color}
                  </span>
                </p>
                <p>
                  <strong>High Court Cases:</strong>{" "}
                  {label.highCourtCases?.length || 0}
                </p>
                <p>
                  <strong>District Court Cases:</strong>{" "}
                  {label.districtCourtCases?.length || 0}
                </p>
                <p>
                  <strong>Other Court Cases:</strong>{" "}
                  {label.otherCourtCases?.length || 0}
                </p>
                <p>
                  <strong>Supreme Court Cases:</strong>{" "}
                  {label.supremeCourtCases?.length || 0}
                </p>
              </div>
            </div>
            <div className="editdel">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setModalTab("Labels");
                  setShowModal(true);
                  onEditLabel(label);
                }}
                className="editbtn"
              >
                <BiEdit size={16} />
              </button>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteClick(label._id, label.name);
                }}
                className="delbtn"
              >
                <BiTrash size={16} />
              </button>
            </div>
          </div>
        ))
      )}

      <LabelSelectionModal
        isOpen={showLabelSelection}
        onClose={() => setShowLabelSelection(false)}
        courtRef={courtRef}
        onLabelAdded={handleLabelAdded}
        setModalTab={setModalTab}
        setShowModal={setShowModal}
        onEditLabel={onEditLabel}
      />
      <DeleteConfirmationModal
        isOpen={deleteModal.isOpen}
        itemType={`this label "${deleteModal.labelName}"`}
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
      />
    </div>
  );
};